<template>
  <div id="chatcontainer">      
    <ChatMessage></ChatMessage>
    <ChatMessageTextBox></ChatMessageTextBox>
  </div>
</template>

<script>
import ChatMessageTextBox from '../../components/ChatMessageTextBox.vue';
import ChatMessage from '../../components/ChatMessage.vue';

export default {
  name: 'chatcontainer',
  components: {    
    ChatMessageTextBox, 
    ChatMessage
  }
}
</script>
 